<template>
  <div>
    <hero
      :title="article.title"
      :description="article.description"
      style="display-1"
      :showLogo="false"
      :showBtnBack="true"
      backRoute="/articles"
    >
    </hero>

    <section class="section">
      <Vue v-if="article.id == 1" />
      <Vuetify v-else-if="article.id == 2" />
      <Postgres v-else-if="article.id == 3" />
      <Node v-else-if="article.id == 4" />
      <Knex v-else-if="article.id == 5" />

      <div v-else class="col-sm-12">
        <div class="row justify-content-center">
          <h3>Ops! Ocorreu um erro ao buscar o artigo que você procura</h3>

          <div class="col-sm-12">
            <div class="text-center mt-5">
              <base-button type="primary" class="my-4" @click="scrollTop"
                >Voltar ao topo</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from "./components/Hero";

import Vue from "./components/articles/Vue";
import Vuetify from "./components/articles/Vuetify";
import Postgres from "./components/articles/Postgres";
import Node from "./components/articles/Node";
import Knex from "./components/articles/Knex";

export default {
  name: "article-by-id",
  computed: {
    article: {
      get() {
        return this.$store.article;
      },
      set(value) {
        this.$store.article = value;
      },
    },
  },
  components: {
    Hero,
    Vue,
    Vuetify,
    Postgres,
    Node,
    Knex,
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style>
</style>